export const StandaloneBankDetailsSentryOpts = {
  tags: {
    page: 'Standalone Bank Details',
  },
};
